// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const EnableACHButton: MarkdocTagRegistration = {
  tag: 'enable-ach-button',
  component: 'EnableACHButton',
};
